import { Components, Theme } from '@mui/material'

export const MuiPaper: Components<Omit<Theme, 'components'>>['MuiPaper'] = {
  defaultProps: {
    // TODO - remove the elevation variant once all usage is removed
    variant: 'outlined',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.default,
      backgroundColor: theme.palette.bg.surface.elevated,
      // MUI paints a dark-mode elevation overlay via --Paper-overlay,
      // which would tint the surface token on elevation Papers
      backgroundImage: 'none',
    }),
    outlined: ({ theme }) => ({
      borderWidth: theme.strokeWidth.default,
      borderStyle: 'solid',
      borderColor: theme.palette.border.subtle,
    }),
    rounded: ({ theme }) => ({
      borderRadius: theme.shape['radius-md'],
      '--paper-border-radius': theme.shape['radius-md'],
    }),
  },
}
